import entityReducer from "./unitEntityReducer";

const reducers = { entities: entityReducer };

export default reducers;
